/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BoxInput from './BoxInput';

const BoxInputs = ({
  handleOutputString,
  amount,
  inputRegExp,
  autoFocus,
  type,
  handleFocusFn,
  handleBlur,
  handleKeyUp,
  className,
}) => {
  const inputElements = {};
  const [characterArray, setCharacterArray] = useState({
    characterArray: Array(amount).fill(null),
  });

  useEffect(() => {
    if (autoFocus) {
      inputElements.input0.select();
    }
  });

  useEffect(() => {
    handleOutputString(characterArray.characterArray.join(''));
  }, [characterArray, handleOutputString]);

  const handleFocus = ({ target }) => {
    handleFocusFn(target);
  };

  const focusPrevChar = (target) => {
    if (target.previousElementSibling !== null) {
      target.previousElementSibling.focus();
    }
  };

  const focusNextChar = (target) => {
    if (target.nextElementSibling !== null) {
      target.nextElementSibling.focus();
      target.setSelectionRange(0, 0);
    }
  };

  const setModuleOutput = () => {
    setCharacterArray((prevState) => {
      const updatedCharacters = prevState.characterArray.map((character, number) => {
        const currentInput = inputElements[`input${number}`];
        if (currentInput.value === '' || !currentInput.value) {
          currentInput.classList.remove('border-primary');
          currentInput.classList.add('border-shadow');
        } else {
          currentInput.classList.add('border-primary');
          currentInput.classList.remove('border-shadow');
        }
        return currentInput.value;
      });
      return { characterArray: updatedCharacters };
    });
  };

  const handleChange = ({ target }) => {
    if (target.value.match(inputRegExp)) {
      focusNextChar(target);
      setModuleOutput(target);
    } else {
      target.value = characterArray.characterArray[parseInt(target.name.replace('input', ''), 10)];
    }
  };

  const handleKeyDown = ({ target, key, shiftKey }) => {
    if (key === 'Backspace' || key === 'Delete') {
      if (target.value === '' && target.previousElementSibling !== null) {
        target.previousElementSibling.value = '';
        focusPrevChar(target);
      } else {
        target.value = '';
        focusNextChar(target);
      }
      setModuleOutput(target);
    }
    if (key === 'ArrowLeft' && !shiftKey) {
      focusPrevChar(target);
    } else if ((key === 'ArrowRight' || key === ' ') && !shiftKey) {
      focusNextChar(target);
    }
  };

  const renderItems = () => {
    const items = [];

    for (let i = 0; i < amount; i++) {
      items.push(
        <BoxInput
          type={type}
          key={i}
          handleKeyDown={handleKeyDown}
          handleFocus={handleFocus}
          handleChange={handleChange}
          handleKeyUp={handleKeyUp}
          handleBlur={handleBlur}
          name={`input${i}`}
          isLast={i + 1 === amount}
          inputRef={(el) => {
            if (!el) return;
            inputElements[el.name] = el;
          }}
        />
      );
    }

    return items;
  };

  const render = () => (
    <div className={`d-flex flex-row justify-content-center ${className}`} style={{ gap: '1rem' }}>
      {renderItems()}
    </div>
  );

  return render();
};

BoxInputs.propTypes = {
  amount: PropTypes.number,
  autoFocus: PropTypes.bool,
  inputRegExp: PropTypes.instanceOf(RegExp),
  password: PropTypes.bool,
  handleOutputString: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleFocusFn: PropTypes.func.isRequired,
  handleKeyUp: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
};

BoxInputs.defaultProps = {
  amount: 5,
  autoFocus: false,
  inputRegExp: /^[0-9]$/,
  password: false,
  handleOutputString: () => {},
};

export default BoxInputs;
